import { useTourContext } from '../contexts';
import { useAddTourFlag } from './useAddTourFlag';
export var useTour = function () {
    var _a = useTourContext(), activateTourFlag = _a.activateTourFlag, completeTourFlag = _a.completeTourFlag, activeFlags = _a.activeFlags, completedFlags = _a.completedFlags;
    var mutate = useAddTourFlag().mutate;
    var complete = function (flag, sync) {
        if (sync === void 0) { sync = true; }
        completeTourFlag(flag);
        if (sync) {
            mutate({
                flag: flag,
            });
        }
    };
    // For cases where tour should not repeat itself regardless of whether user actively engages (ie undo note)
    var silentComplete = function (flag) {
        mutate({
            flag: flag,
        });
    };
    return {
        activate: activateTourFlag,
        complete: complete,
        silentComplete: silentComplete,
        activeFlags: activeFlags,
        completedFlags: completedFlags,
    };
};
